import React from 'react';
import { Image, StyleSheet, Text, View } from './base_components';

import Select from './select';

import UserStore from '../stores/user_store';

const styles = StyleSheet.create({
  orgSelect: {
    paddingLeft: '1em',
    height: '2em',
    fontSize: '1.3em',
  },
  customView: {
    paddingLeft: '1em',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  customDomain: {},
  iconView: {
    position: 'absolute',
    right: '0.7rem',
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '2rem',
    height: '2rem',
  },
});

const ARROWS = require('../assets/img/arrows_grey.svg');

type Props = {
  style?: any;
};
export default function OrgSelect(props: Props) {
  const org = UserStore.useOrg();
  const org_list = UserStore.useUser()?.org_list ?? [];
  const custom_domain = UserStore.getCustomDomain();

  function _onPress(org_id) {
    UserStore.setCurrentOrgId(org_id);
  }

  let content: any = null;
  if (custom_domain) {
    content = (
      <View style={[styles.customView, props.style]}>
        <Text style={styles.customDomain}>{custom_domain}</Text>
      </View>
    );
  } else if (org_list) {
    const options = [
      ...org_list.map((v) => ({
        value: v.org_id,
        text: v.org_name,
      })),
    ];

    content = (
      <>
        <View style={styles.iconView}>
          <Image style={styles.icon} source={ARROWS} />
        </View>
        <Select
          style={[styles.orgSelect, props.style]}
          options={options}
          value={org?.org_id}
          onChange={_onPress}
        />
      </>
    );
  }
  return content;
}
